import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import { useState } from "react";
import CustomSelect from "../../ui/select/Select";

const StepperModal = ({ open, title, onClose, onConfirm }) => {
  const [selectedOption, setSelectedOption] = useState("completado");
  const [errorReason, setErrorReason] = useState("");
  const [details, setDetails] = useState("");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleReasonChange = (event) => {
    setErrorReason(event.target.value);
  };

  const handleDetailsChange = (event) => {
    setDetails(event.target.value);
  };

  const handleConfirm = () => {
    onConfirm(selectedOption, errorReason, details);
    handleClose();
  };

  const handleClose = () => {
    setSelectedOption("completado");
    setErrorReason("");
    setDetails("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", gap: "16px", padding: "0px 0 70px" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ fontSize: "14px", color: "gray", margin: 0 }}>
              Estatus:
            </p>
            <CustomSelect
              placeholder="Estatus"
              value={selectedOption}
              onChange={handleOptionChange}
              options={[
                { value: "completado", name: "Completado" },
                { value: "pendiente", name: "Pendiente" },
                { value: "error", name: "Error" },
              ]}
              name={"statussss"}
              topOption={"30px"}
              heightOption={"90px"}
              width={"200px"}
              textAlign={"left"}
              color={"#6c757d"}
              fontSize={"14px"}
              fontWeight={600}
              marginBottom={"24px"}
              optionsWidth={"200px"}
            />
          </div>

          {selectedOption === "error" && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ fontSize: "14px", color: "gray", margin: 0 }}>
                Error:
              </p>
              <CustomSelect
                placeholder="Razón de error"
                value={errorReason}
                onChange={handleReasonChange}
                options={[
                  { value: "Falta de materiales", name: "Falta de materiales" },
                  { value: "Problemas técnicos", name: "Problemas técnicos" },
                  {
                    value: "Condiciones climáticas",
                    name: "Condiciones climáticas",
                  },
                  { value: "Otros", name: "Otros" },
                ]}
                name={"errorrr"}
                topOption={"30px"}
                heightOption={"110px"}
                width={"200px"}
                textAlign={"left"}
                color={"#6c757d"}
                fontSize={"14px"}
                fontWeight={600}
                marginBottom={"24px"}
                optionsWidth={"200px"}
              />
            </div>
          )}
          {(selectedOption === "completado" ||
            selectedOption === "pendiente") && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ fontSize: "14px", color: "gray", margin: 0 }}>
                Detalles:
              </p>
              <textarea
                id="details"
                value={details}
                onChange={handleDetailsChange}
                rows={4}
                style={{ width: "100%" }}
              />
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Aceptar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};
export default StepperModal;
